import i18n from '../../../../i18n';

/**
 * 加开流程「账户类型」展示口径（与 SelectTypes 选类型页一致）：
 * 衍生产品、A股通 已迁至 App「交易品种」激活；加开仅保留证券/基金账户类别。
 * 历史申请 securitiesAccountType 可能仍含相关 code — 列表与续办回填 intentionally 过滤，非接口缺失。
 */

export const isDerivativeSecuritiesType = (code: string, label = '') => {
  const value = String(code || '');
  const text = String(label || '');
  if (/DERIV/i.test(value)) return true;
  if (/衍生|Derivative/i.test(text)) return true;
  if (text === i18n.OpenProgress.Info.Investment.IntendTradeDerivative) return true;
  return false;
};

export const isChinaConnectSecuritiesType = (code: string, label = '') => {
  const value = String(code || '');
  const text = String(label || '');
  if (value === 'CHINA_CONNECT') return true;
  if (/A股通|China Connect/i.test(text)) return true;
  return false;
};

/** 加开选类型 / 申请列表：不展示、不回显的类型（已迁「交易品种」） */
export const isExcludedFromAddAccountDisplay = (code: string, label = '') =>
  isDerivativeSecuritiesType(code, label) || isChinaConnectSecuritiesType(code, label);

export function filterAddAccountDisplayTypeCodes(
  codes: string[],
  secMap: Record<string, string>,
  fundMap: Record<string, string>,
): string[] {
  return codes.filter((code) => {
    const trimmed = String(code || '').trim();
    if (!trimmed) return false;
    const label = secMap[trimmed] ?? fundMap[trimmed] ?? '';
    return !isExcludedFromAddAccountDisplay(trimmed, label);
  });
}

/** 历史 accountType 合串（中文、顿号）去掉已迁「交易品种」的项 */
export function filterAddAccountDisplayLabelText(text: string | null | undefined): string {
  const raw = String(text ?? '').trim();
  if (!raw) return '';
  const parts = raw.split(/[,、]/).map((s) => s.trim()).filter(Boolean);
  const kept = parts.filter((part) => !isExcludedFromAddAccountDisplay('', part));
  return kept.join('、');
}
